import { IApplicationState } from '../../types/redux';

export function selectMoneyBalance(state: IApplicationState) {
  return state.fieldsState.moneyBalance;
}
